module.exports = __webpack_public_path__ + "static/media/Image 40.11decd12.png";